export default function QrScan() {
    return (
        <div className="qrscan-page-content">
            <h1>QR Scan</h1>
        </div>
    );
}